<template>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="14.582" cy="5" r="2.5" stroke="currentColor" stroke-width="1.25"/>
        <path d="M12.082 17.5H14.9987C16.1493 17.5 17.082 16.5673 17.082 15.4167V12.5" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M7.91602 2.5L4.99935 2.5C3.84876 2.5 2.91602 3.43274 2.91602 4.58333L2.91602 7.5" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
        <circle cx="5" cy="15" r="2.5" stroke="currentColor" stroke-width="1.25"/>
        <path d="M6.66602 12.9167L12.4993 7.08334" stroke="currentColor" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>
